import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import DateiVorschau from '../components/datei/DateiVorschau';

/**
 * Eine Datei für sich (z. B. aus „Letzte Änderungen“ oder als Link): dieselbe Vorschau wie neben dem Chat — Original
 * vom Laufwerk, Text, Speicherort. `?a=` springt zur Fundstelle, `?q=` markiert Begriffe. Rechte prüft das Backend.
 */
export default function Datei() {
  const { id } = useParams<{ id: string }>();
  const [p] = useSearchParams();
  const navigate = useNavigate();
  const a = p.get('a');
  const zurueck = () => (window.history.length > 1 ? navigate(-1) : navigate('/'));
  if (!id) return null;
  return (
    <div className="mx-auto h-[calc(100dvh-7rem)] max-w-5xl">
      <DateiVorschau id={id} q={p.get('q') ?? ''} um={a !== null && a !== '' ? Number(a) : null} onClose={zurueck} />
    </div>
  );
}
